var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAttachedToInvoice)?_c('icon-button',{attrs:{"disabled":true,"icon":"fa fa-check","tooltip":_vm.$t('InvoiceItems_ATetelMarSzerepelASzamlan')}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }